// extracted by mini-css-extract-plugin
module.exports = {"WhiteContainer":"IndividualCoverageInformation_WhiteContainer__3D915","Container":"IndividualCoverageInformation_Container__2efok"};